import styled from 'styled-components';

export const TopHeading = styled.h1`
  margin-bottom: 30px;
`;

export const Heading = styled.h2`
  margin-bottom: 30px;
`;
